import React from 'react';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  return <section id="testimonials" className="py-16 bg-[#F8F9FA]" data-id="element-381">
      <div className="container mx-auto px-4" data-id="element-382">
        <div className="text-center mb-12" data-id="element-383">
          <div className="flex justify-center mb-4" data-id="element-384">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-10 h-10" data-id="element-385" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B365D] mb-4" data-id="element-386">
            What Southwest Florida Homeowners Say
          </h2>
          <div className="flex items-center justify-center mb-4" data-id="element-387">
            <Star className="text-[#D4AF37] fill-[#D4AF37]" size={24} data-id="element-388" />
            <Star className="text-[#D4AF37] fill-[#D4AF37]" size={24} data-id="element-389" />
            <Star className="text-[#D4AF37] fill-[#D4AF37]" size={24} data-id="element-390" />
            <Star className="text-[#D4AF37] fill-[#D4AF37]" size={24} data-id="element-391" />
            <div className="relative" data-id="element-392">
              <Star className="text-[#D4AF37]" size={24} data-id="element-393" />
              <div className="absolute top-0 left-0 overflow-hidden" style={{
              width: '80%'
            }} data-id="element-394">
                <Star className="text-[#D4AF37] fill-[#D4AF37]" size={24} data-id="element-395" />
              </div>
            </div>
            <span className="ml-2 text-lg font-bold text-[#2C3E50]" data-id="element-396">
              4.8 out of 5 stars
            </span>
          </div>
          <p className="text-[#2C3E50] text-lg max-w-3xl mx-auto" data-id="element-397">
            Based on 1000's of satisfied customers
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-398">
          <TestimonialCard name="Sarah Johnson" location="Fort Myers, FL" image="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80" quote="Jeff was incredibly thorough and professional. He found issues that would have cost us thousands to fix after purchase. The report was detailed and easy to understand. Worth every penny!" rating={4} data-id="element-399" />
          <TestimonialCard name="Michael Rodriguez" location="Naples, FL" image="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80" quote="The wind mitigation inspection saved us over $800 annually on our insurance premium. Jeff explained everything clearly and delivered the report the same day. Excellent service!" rating={5} data-id="element-400" />
          <TestimonialCard name="Jennifer Williams" location="Cape Coral, FL" image="https://uploadthingy.s3.us-west-1.amazonaws.com/nxxAkdXybFwQjUvRs67CSf/jenwilliamstestimonal.png" quote="As a first-time homebuyer, I was nervous about the inspection process. Jeff took the time to walk me through everything and answer all my questions. His report was comprehensive and he even provided maintenance tips!" rating={5} data-id="element-401" />
          <TestimonialCard name="David Thompson" location="Bonita Springs, FL" image="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80" quote="Jeff's attention to detail is impressive. He identified a potential mold issue that wasn't visible to the naked eye using his thermal imaging equipment. His expertise saved us from a major headache down the road." rating={5} data-id="element-402" />
          <TestimonialCard name="Amanda Garcia" location="Estero, FL" image="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=388&q=80" quote="I've used Crown Inspection Services for three different properties now. Jeff is always punctual, professional, and thorough. I wouldn't use anyone else for my inspection needs in Southwest Florida." rating={4} data-id="element-403" />
          <TestimonialCard name="Robert Chen" location="Fort Myers, FL" image="https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1148&q=80" quote="As a real estate agent, I've worked with many inspectors over the years. Jeff stands out for his professionalism, knowledge, and ability to explain findings to my clients in a way that doesn't alarm them unnecessarily." isRealtor={true} rating={4.5} data-id="element-404" />
        </div>
      </div>
    </section>;
}
interface TestimonialCardProps {
  name: string;
  location: string;
  image: string;
  quote: string;
  isRealtor?: boolean;
  rating?: number;
}
function TestimonialCard({
  name,
  location,
  image,
  quote,
  isRealtor = false,
  rating = 5
}: TestimonialCardProps) {
  return <div className="bg-white rounded-lg p-6 shadow-lg flex flex-col h-full relative" data-id="element-405">
      <Quote size={40} className="absolute top-4 right-4 text-gray-100" data-id="element-406" />
      <div className="flex items-center mb-4 z-10" data-id="element-407">
        <img src={image} alt={name} className="w-16 h-16 rounded-full object-cover mr-4 border-2 border-[#D4AF37]" data-id="element-408" />
        <div data-id="element-409">
          <h3 className="font-bold text-[#1B365D]" data-id="element-410">{name}</h3>
          <p className="text-gray-600 text-sm" data-id="element-411">{location}</p>
          {isRealtor && <span className="bg-[#1B365D] text-white text-xs px-2 py-0.5 rounded mt-1 inline-block" data-id="element-412">
              Real Estate Professional
            </span>}
        </div>
      </div>
      <div className="flex mb-4 z-10" data-id="element-413">
        {[1, 2, 3, 4, 5].map(star => {
        if (star <= Math.floor(rating)) {
          // Full star
          return <Star key={star} className="text-[#D4AF37] fill-[#D4AF37]" size={16} data-id="element-414" />;
        } else if (star === Math.ceil(rating) && !Number.isInteger(rating)) {
          // Half star
          return <div key={star} className="relative" data-id="element-415">
                <Star className="text-[#D4AF37]" size={16} data-id="element-416" />
                <div className="absolute top-0 left-0 overflow-hidden" style={{
              width: `${rating % 1 * 100}%`
            }} data-id="element-417">
                  <Star className="text-[#D4AF37] fill-[#D4AF37]" size={16} data-id="element-418" />
                </div>
              </div>;
        } else {
          // Empty star
          return <Star key={star} className="text-[#D4AF37]" size={16} data-id="element-419" />;
        }
      })}
      </div>
      <p className="text-[#2C3E50] italic flex-grow z-10" data-id="element-420">"{quote}"</p>
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-6 h-6 absolute bottom-4 right-4 opacity-20" data-id="element-421" />
    </div>;
}
function ArrowRight(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={props.size || 24} height={props.size || 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={props.className} data-id="element-422">
      <path d="M5 12h14" data-id="element-423"></path>
      <path d="m12 5 7 7-7 7" data-id="element-424"></path>
    </svg>;
}